import { render, staticRenderFns } from "./InviteCollaborator.vue?vue&type=template&id=84a53076&scoped=true"
import script from "./InviteCollaborator.vue?vue&type=script&lang=js"
export * from "./InviteCollaborator.vue?vue&type=script&lang=js"
import style0 from "./InviteCollaborator.vue?vue&type=style&index=0&id=84a53076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a53076",
  null
  
)

export default component.exports